import { z } from "@hono/zod-openapi";

import { NANO_ID_SLUGS } from "./id-constants";

export const NanoIdSchema = z.string().brand("NanoId").openapi({
  format: 'nanoid',
})

export type NanoId = z.infer<typeof NanoIdSchema>;

export const AuthConfigNanoIdSchema = NanoIdSchema.brand("AuthConfigId").refine(
  (id) =>{
    // Revert when every auth config has prefix
    return true;
    return (
      id.startsWith(NANO_ID_SLUGS.AUTH_CONFIG.PREFIX) &&
      id.replace(NANO_ID_SLUGS.AUTH_CONFIG.PREFIX, '').length === NANO_ID_SLUGS.AUTH_CONFIG.LENGTH
    );
  },
  {
    message: `Invalid auth config id should start with ds ${NANO_ID_SLUGS.AUTH_CONFIG.PREFIX}`,
  },
).openapi({
  format: 'authConfigId',
})

export type AuthConfigNanoId = z.infer<typeof AuthConfigNanoIdSchema>;

export const ConnectedAccountNanoIdSchema = NanoIdSchema.brand(
  "ConnectedAccountId",
).refine(
  (id) =>{
    // Revert when every connected account has prefix
    return true;
    return (
      id.startsWith(NANO_ID_SLUGS.CONNECTED_ACCOUNT.PREFIX) &&
      id.replace(NANO_ID_SLUGS.CONNECTED_ACCOUNT.PREFIX, '').length === NANO_ID_SLUGS.CONNECTED_ACCOUNT.LENGTH
    );
  },
  {
    message: `Invalid connected account id should start with ${NANO_ID_SLUGS.CONNECTED_ACCOUNT.PREFIX}`,
  },
).openapi({
  format: 'connectedAccountId',
})

export type ConnectedAccountNanoId = z.infer<typeof ConnectedAccountNanoIdSchema>;

export const TriggerInstanceNanoIdSchema = NanoIdSchema.brand(
  "TriggerInstanceId",
).refine(
  (id) => {
    // Revert when every trigger instance has prefix
    return true;
    return (
      id.startsWith(NANO_ID_SLUGS.TRIGGER_INSTANCE.PREFIX) &&
      id.replace(NANO_ID_SLUGS.TRIGGER_INSTANCE.PREFIX, '').length === NANO_ID_SLUGS.TRIGGER_INSTANCE.LENGTH
    );
  },
  {
    message: `Invalid trigger instance id should start with ${NANO_ID_SLUGS.TRIGGER_INSTANCE.PREFIX}`,
  },
).openapi({
  format: 'triggerInstanceId',
})

export type TriggerInstanceNanoId = z.infer<typeof TriggerInstanceNanoIdSchema>;

export const OrgNanoIdSchema = NanoIdSchema.brand("OrgId").refine(
  (id) =>{
    // Revert when every project has prefix
    return true;
    return (
      id.startsWith(NANO_ID_SLUGS.ORG.PREFIX) &&
      id.replace(NANO_ID_SLUGS.ORG.PREFIX, '').length === NANO_ID_SLUGS.ORG.LENGTH
    );
  },
  {
    message: `Invalid org id should start with ${NANO_ID_SLUGS.ORG.PREFIX}`,
  },
).openapi({
  format: 'orgId',
})

export type OrgNanoId = z.infer<typeof OrgNanoIdSchema>;

export const ProjectNanoIdSchema = NanoIdSchema.brand("ProjectId").refine(
  (id) => {
    // Revert when every project has prefix
    return true;
    const { PREFIX, LENGTH, BACKWARD_COMPATIBILITY_PREFIX } =
      NANO_ID_SLUGS.PROJECT;
    return (
      (id.startsWith(PREFIX) && id.length === LENGTH) ||
      (BACKWARD_COMPATIBILITY_PREFIX !== undefined &&
        id.startsWith(BACKWARD_COMPATIBILITY_PREFIX) &&
        id.replace(BACKWARD_COMPATIBILITY_PREFIX, '').length === LENGTH)
    );
  },
  {
    message:
      `Invalid project id: should start with ${NANO_ID_SLUGS.PROJECT.PREFIX}` +
      (NANO_ID_SLUGS.PROJECT.BACKWARD_COMPATIBILITY_PREFIX
        ? ` or ${NANO_ID_SLUGS.PROJECT.BACKWARD_COMPATIBILITY_PREFIX}`
        : ""),
  },
).openapi({
  format: 'projectId',
})

export type ProjectNanoId = z.infer<typeof ProjectNanoIdSchema>;

export const ProjectAutoIdSchema = z.number().brand("ProjectAutoId").openapi({
  format: 'projectAutoId',
})

export const ProjectAutoIdStringSchema = z.string().brand("ProjectAutoIdString").openapi({
  format: 'projectAutoIdString',
})

export type ProjectAutoIdString = z.infer<typeof ProjectAutoIdStringSchema>;

export const convertProjectAutoIdToProjectAutoIdString = (id: ProjectAutoId): ProjectAutoIdString => {
  return ProjectAutoIdStringSchema.parse(id.toString())
}

export type ProjectAutoId = z.infer<typeof ProjectAutoIdSchema>;

export const UUIDSchema = z.string().brand("UUID").openapi({
  format: 'uuid',
})

export type UUID = z.infer<typeof UUIDSchema>;
